"use client"

import { useState } from "react"
import { Menu, X } from "lucide-react"
import { cn } from "@/lib/utils"

const sections = [
  { id: "epistemic-crisis", title: "The Epistemic Crisis", number: "01" },
  { id: "market-anomaly", title: "The Market Anomaly", number: "02" },
  { id: "economics-of-thought", title: "Economics of Thought", number: "03" },
  { id: "ontological-grounding", title: "Ontological Grounding", number: "04" },
  { id: "orchestration-dynamics", title: "Orchestration Dynamics", number: "05" },
  { id: "universal-interoperability", title: "Universal Interoperability", number: "06" },
  { id: "epistemic-security", title: "Epistemic Security", number: "07" },
  { id: "european-market", title: "European SME Market", number: "08" },
  { id: "margin-of-safety", title: "Margin of Safety", number: "09" },
]

export function MobileTableOfContents() {
  const [isOpen, setIsOpen] = useState(false)

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    if (element) {
      const offset = 100
      const elementPosition = element.getBoundingClientRect().top + window.scrollY
      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth",
      })
      setIsOpen(false)
    }
  }

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setIsOpen(true)}
        className="lg:hidden fixed bottom-6 right-6 z-40 p-4 bg-foreground text-background rounded-full shadow-lg hover:opacity-90 transition-opacity"
        aria-label="Open table of contents"
      >
        <Menu className="w-5 h-5" />
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 z-50 bg-background/80 backdrop-blur-sm"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Drawer */}
      <div
        className={cn(
          "lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border rounded-t-2xl transform transition-transform duration-300 ease-out",
          isOpen ? "translate-y-0" : "translate-y-full"
        )}
      >
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
              Contents
            </p>
            <button
              onClick={() => setIsOpen(false)}
              className="p-2 hover:bg-muted rounded-md transition-colors"
              aria-label="Close table of contents"
            >
              <X className="w-5 h-5 text-muted-foreground" />
            </button>
          </div>

          <nav className="space-y-1 max-h-[60vh] overflow-y-auto">
            {sections.map(({ id, title, number }) => (
              <button
                key={id}
                onClick={() => scrollToSection(id)}
                className="group flex items-start gap-3 w-full text-left py-3 px-3 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
              >
                <span className="text-xs font-mono mt-0.5 text-muted-foreground/60">
                  {number}
                </span>
                <span className="text-sm leading-snug">{title}</span>
              </button>
            ))}
          </nav>
        </div>
      </div>
    </>
  )
}
